import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ModelService } from '../../../../core/services/model/model.service';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { LocalStorageService } from '../../../../core/services/localStorage/local-storage.service';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { AuthStateService } from '../../../../core/services/auth-state/auth-state-service.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { copyToClipboard as copyToClipboardUtil } from '../../../../core/utils/clipboard.utils';

interface AccountData {
  reference: string;
  lastname: string;
  name: string;
  type: string;
  tax_id: string;
  billing_address: string;
  billing_city: string;
  billing_state: string;
  root_account: any;
  status: boolean;
}

@Component({
  selector: 'app-general-form',
  standalone: true,
  imports: [ReactiveFormsModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    NgSelectModule,
    CommonModule],
  templateUrl: './general-form.component.html',
  styleUrl: './general-form.component.css'
})
export class GeneralFormComponent {
  @Input() stockData?: any;
  @Input() ladata: any = [];

  @Output() emitSubmit = new EventEmitter<string>();
  account_type = this.authStateService.getAccountType();

  generalForm: FormGroup = new FormGroup({});

  draft = false;
  stage?: any;
  newStage: string = '';

  role: any;

  back = "";
  next_ok = "";
  next_ko = "";
  btn_fast_actions = false;
  agentData: AccountData[] = [];
  vendorData: AccountData[] = [];
  brokerData: AccountData[] = [];
  supplierData: AccountData[] = [];
  stagesList: { key: string }[] = [];
  supplierTypeData: any[] = [{ name: 'Prescripción broker', key: 'referral_broker' }, { name: 'Prescripción devolución', key: 'referral_vendor' }];
  supplierSellerCodes: any[] = [];

 @Output() brokerSelected = new EventEmitter<string>();


  constructor(private fb: FormBuilder, private authStateService: AuthStateService, private modelService: ModelService, private alertService: AlertService, private localStorageService: LocalStorageService, private orderService: OrdersService) {
    this.generalForm = this.fb.group({
      campaign_stock_reference: ['', Validators.required],
      units: ['', Validators.required],
      hidden_units: [''],
      stage: ['', Validators.required],
      delivery_comments: ["", Validators.required],
      comments: ["", Validators.required],
    });
  }

  ngOnInit(): void {
      this.generalForm.get('broker_id')?.valueChanges.subscribe(brokerId => {
          
            this.brokerSelected.emit(brokerId);
        });
  }

  ngAfterViewInit() {

  }
  check_selects_length() {
    if (this.brokerData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ broker_id: this.brokerData[0].reference });
    }
    if (this.vendorData.length === 1) {
      // Selecciona automáticamente la única opción
      this.generalForm.patchValue({ vendor_id: this.vendorData[0].reference });
    }
  }

  checkUpdateForm(): boolean {
    if (this.generalForm.dirty) {
      return true;
    } else {
      return false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes['ladata'] && this.ladata.flag) {

        this.role = this.authStateService.getRole();
        this.agentData = this.ladata.agentData;
        this.vendorData = this.ladata.vendorData?.slice().sort((a: AccountData, b: AccountData) => a.name.localeCompare(b.name));
        this.brokerData = this.ladata.brokerData?.slice().sort((a: AccountData, b: AccountData) => a.name.localeCompare(b.name));
        this.supplierSellerCodes = this.ladata.supplierSellerCodes;
        this.supplierData = this.ladata.supplierData;
        this.check_selects_length();

        if (this.account_type == 'broker' && !this.draft) {
          this.generalForm.controls['broker_agent_id'].setValue(
            this.authStateService.getUserReference()
          );
        }
        if (this.stockData) {
          this.refrescarFormulario();
        }
      }

      if (changes['stockData']) {
        if (this.stockData) {
          this.refrescarFormulario();
        }
      }
    }
  }

  changeStage(event: any) {
    this.newStage = event;
    this.btn_fast_actions = false;
  }

  refrescarFormulario() {
    this.setVariables();
    // Construir stagesList para ng-select del stage
    if (this.stockData?.stages) {
      const stagesSet = new Set<string>([
        ...(this.stockData.stage ? [this.stockData.stage] : []),
        ...this.stockData.stages,
      ]);
      this.stagesList = Array.from(stagesSet).map(k => ({ key: k }));
    }
    this.updateFieldAccessibility();
    for (const key in this.stockData) {
      const control = this.generalForm.controls[key];
      const value = this.stockData[key];
      if (control) {
        control.setValue(value);
      }
      if (control) {
        switch (key) {
          case 'broker_agent_id':
            if (this.account_type === 'broker') {
              control.setValue(value);
            } else {
              const brokerAgentName = `${this.stockData?.broker_agent?.name || ''} ${this.stockData?.broker_agent?.lastname || ''}`.trim();
              this.generalForm.get('broker_agent')?.setValue(brokerAgentName);
              control.setValue(value);
            }
            break;
          case 'supplier_agent_id':
            if (this.account_type === 'supplier') {
              control.setValue(value);
            } else {
              const supplierAgentName = `${this.stockData?.supplier_agent?.name || ''} ${this.stockData?.supplier_agent?.lastname || ''}`.trim();
              this.generalForm.get('supplier_agent')?.setValue(supplierAgentName);
              control.setValue(value);
            }
            break;
          case 'notes':

            this.generalForm.get('notes')?.setValue("");
            break;
          default:
            control.setValue(value);
            break;
        }
      }


    }
    this.btn_fast_actions = this.stockData?.next_ok || this.stockData?.next_ko ? true : false;
    this.alertService.close();
  }

  updateFieldAccessibility() {
    var rules = { ... this.stockData?.rules };
    // Deshabilitar todos los campos por defecto
    for (const field in this.generalForm.controls) {
      if (this.generalForm.controls.hasOwnProperty(field)) {
        this.generalForm.get(field)?.disable();
      }
    }

    // Habilitar solo los campos con valor 'w' en las reglas
    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.generalForm.get(field)?.enable();
      }
    }

  }

  onSubmitOrderFast(stage: string) {
    this.emitSubmit.emit(stage);
  }

  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }

  setVariables() {
    this.back = this.stockData?.back || '';
    this.next_ok = this.stockData?.next_ok;
    this.next_ko = this.stockData?.next_ko;
    this.stage = this.stockData?.stage;
    this.draft = this.stockData ? true : false;
  }

  @Input() hasExcludedBrokers: boolean = false;
}
